// extracted by mini-css-extract-plugin
module.exports = {"cancelBtn":"TableHeader_cancelBtn__1vL5-","applyBtn":"TableHeader_applyBtn__ItB72","buttonCont":"TableHeader_buttonCont__aZD0D"};